import {
	Box,
	Button,
	IconButton,
	LinearProgress,
	TextField,
	Tooltip,
	Typography,
	useMediaQuery,
	useTheme,
} from '@material-ui/core';
import { Link, generatePath, useHistory, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { faCopy, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { loadLinkPagamentoFilter, loadLinkPagamentos } from '../../../actions/actions';
import { useDispatch, useSelector } from 'react-redux';

import { CopyToClipboard } from 'react-copy-to-clipboard';
import CustomBreadcrumbs from '../../reusable/CustomBreadcrumbs/CustomBreadcrumbs';
import CustomTable from '../../reusable/CustomTable/CustomTable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import GradientButton from '../../reusable/GradientButton/GradientButton';
import Pagination from '@material-ui/lab/Pagination';
import SearchBar from '../../reusable/SearchBar/SearchBar';
import { toast } from 'react-toastify';
import useAuth from '../../../hooks/useAuth';
import useDebounce from '../../../hooks/useDebounce';

const columns = [
	{
		headerText: 'Criado em',
		key: 'created_at',
		CustomValue: (data) => {
			const date = new Date(data);
			const option = {
				year: 'numeric',
				month: 'numeric',
				day: 'numeric',
			};
			const formatted = date.toLocaleDateString('pt-br', option);
			return <Typography align="center"> {formatted}</Typography>;
		},
	},
	{
		headerText: 'Link de acesso',
		key: 'id',
		CustomValue: (id) => {
			return (
				<Box display="flex" justifyContent="center" alignItems="center">
					<TextField
						variant="outlined"
						value={`${process.env.REACT_APP_LINK_PAGAMENTO_URL}/${id}/pagar`}
						disabled
					/>
					<Tooltip title="Copiar">
						<CopyToClipboard text={`${process.env.REACT_APP_LINK_PAGAMENTO_URL}/${id}/pagar`}>
							<IconButton
								aria="Copiar"
								style={{
									marginLeft: '6px',

									alignSelf: 'center',
									color: 'green',
								}}
								onClick={() =>
									toast.success('Link copiado com sucesso', {
										autoClose: 2000,
									})
								}
							>
								<FontAwesomeIcon style={{ fontSize: '1.4rem' }} icon={faCopy} />
							</IconButton>
						</CopyToClipboard>
					</Tooltip>
				</Box>
			);
		},
	},

	{
		headerText: 'Situação',
		key: 'status',
		CustomValue: (status) => {
			return status === 'Ativo' ? (
				<Typography
					style={{
						color: 'green',
						fontWeight: 'bold',
						borderRadius: '27px',
					}}
				>
					{status}
				</Typography>
			) : (
				<Typography
					style={{
						color: '#dfad06',
						fontWeight: 'bold',
						borderRadius: '27px',
					}}
				>
					{status}
				</Typography>
			);
		},
	},
	{ headerText: 'Parcelas', key: 'limite_parcelas' },
	{ headerText: 'Limite', key: 'quantidade_utilizacoes' },
	{
		headerText: 'Vencimento',
		key: 'vencimento',
		CustomValue: (data) => {
			if (data !== null) {
				const p = data.split(/\D/g);
				const dataFormatada = [p[2], p[1], p[0]].join('/');
				return <Typography align="center">{dataFormatada}</Typography>;
			}
		},
	},
	{
		headerText: 'Valor',
		key: 'valor',
		CustomValue: (value) => <p>R$ {value}</p>,
	},
	{
		headerText: 'Descrição',
		key: 'descricao',
		CustomValue: (descricao) => {
			return (
				<Tooltip title={descricao ? descricao : 'Sem descrição'}>
					<Box>
						<FontAwesomeIcon icon={faQuestionCircle} />
					</Box>
				</Tooltip>
			);
		},
	},
];

const AccountStatement = () => {
	const token = useAuth();
	const [filters, setFilters] = useState({
		like: '',
		order: '',
		mostrar: '',
	});
	const debouncedLike = useDebounce(filters.like, 800);
	const dispatch = useDispatch();
	const [page, setPage] = useState(1);
	const theme = useTheme();
	const history = useHistory();
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	const userData = useSelector((state) => state.userData);
	const { id } = useParams();
	useEffect(() => {
		return () => {
			setFilters({ ...filters });
		};
	}, []);

	useEffect(() => {
		dispatch(loadLinkPagamentoFilter(token, page, debouncedLike, filters.order, filters.mostrar, id));
	}, [page, debouncedLike, filters.order, filters.mostrar, id]);

	const linkPagamentos = useSelector((state) => state.linkPagamentos);

	const handleChangePage = (e, value) => {
		setPage(value);
	};

	const handleClickRow = (row) => {
		const path = generatePath('/dashboard/detalhes-link/:id/ver', {
			id: row.id,
		});
		history.push(path);
	};

	return (
		<Box display="flex" flexDirection="column">
			{token && userData === '' ? (
				<CustomBreadcrumbs path1="Gerenciar Listas" to1="goBack" path2="Link de pagamento" />
			) : (
				<CustomBreadcrumbs path1="Link de pagamento" />
			)}
			<Box display="flex" justifyContent="space-between" flexDirection={matches ? 'column' : null}>
				<Typography style={{ marginTop: '8px' }} variant="h4">
					Link de Pagamento
				</Typography>

				{token && userData === '' ? null : (
					<Link to="novo-link-pagamento">
						<GradientButton buttonText="+Novo Link" />
					</Link>
				)}
			</Box>
			<Box marginTop="16px" marginBottom="16px">
				<SearchBar
					fullWidth
					placeholder="Pesquisar por valor, descrição, número do pedido..."
					value={filters.like}
					onChange={(e) =>
						setFilters({
							...filters,
							like: e.target.value,
						})
					}
				/>
			</Box>

			{linkPagamentos.data && linkPagamentos.per_page ? (
				<CustomTable columns={columns} data={linkPagamentos.data} handleClickRow={handleClickRow} />
			) : (
				<LinearProgress />
			)}
			<Box alignSelf="flex-end" marginTop="8px">
				<Pagination
					variant="outlined"
					color="secondary"
					size="large"
					count={linkPagamentos.last_page}
					onChange={handleChangePage}
					page={page}
				/>
			</Box>
		</Box>
	);
};

export default AccountStatement;
